// Supabase table and column name constants
export const DB = {
  ASSETS:              'Assets',
  LIABILITIES:         'Liabilities',
  ASSETS_HISTORY:      'Assets History',
  LIABILITIES_HISTORY: 'Liabilities History',
  ASSET_ID:            'asset_id',
  LIABILITY_ID:        'liability_id',
};

export const CLASSES = ["Property", "Pension", "Investment", "Savings", "Other", "Mortgage", "Long Term Debt", "Short Term Debt"];
export const ASSET_CLASSES = ["Property", "Pension", "Investment", "Savings", "Other"];
export const LIABILITY_CLASSES = ["Mortgage", "Long Term Debt", "Short Term Debt"];
export const CLASS_LABELS = {Property: "Properties", Pension: "Pensions", Investment: "Investments", Savings: "Savings", Other: "Other", Mortgage: "Mortgages", "Long Term Debt": "Long Term Debts", "Short Term Debt": "Short Term Debts"};
export const CLASS_COLOUR_MAP = { Property: "var(--property)", Pension: "var(--pension)", Investment: "var(--investment)", Savings: "var(--savings)", Other: "var(--other)", Mortgage: "var(--mortgage)", "Long Term Debt": "var(--long-term-debt)", "Short Term Debt": "var(--short-term-debt)", "Net Worth": "var(--networth)", };




// Locale and currency format options
export const LOCALE = "en-GB";
export const CURRENCY_LONG = {style: "currency", currency: "GBP", currencyDisplay: "narrowSymbol", minimumFractionDigits: 0, maximumFractionDigits: 0};
export const CURRENCY_SHORT = {...CURRENCY_LONG, notation: "compact", compactDisplay: "short", minimumFractionDigits: 0, maximumFractionDigits: 0};

// Shared Nivo chart theme for history cards
export const CHART_THEME = {
  axis: {
    domain: {line: {stroke: "transparent", strokeWidth: 0}},
    ticks: {
      line: {stroke: "transparent", strokeWidth: 0},
      text: {fill: "var(--l3)", fontWeight: "350", fontSize: "1em"},
    },
  },
  crosshair: {line: {stroke: "white", strokeWidth: 1, strokeOpacity: 0.75}},
  grid: {line: {stroke: "var(--d1)", strokeWidth: 1}},
};

// Shared period options for timeline history cards
export const PERIODS = [
  {value: "1m", label: "1M"},
  {value: "1y", label: "1Y"},
  {value: "ytd", label: "YTD"},
  {value: "all", label: "All"},
];

// Text overrides for react-timeago
export const TIMEAGO_TEXT = ["Just now", "Right now"];

// Year range options for the forecast panel
export const YEAR_OPTIONS = [10, 20, 30, 40, 50];
